module.exports = __webpack_public_path__ + "static/media/abandoned-basket.b4ff6d14.jpg";